import React from 'react';
import cn from 'classnames';
import { Radio } from '../Radio/Radio';

export interface AnswerOption {
  label: string;
  value: string;
}

export interface AnswerListProps {
  options: AnswerOption[];
  name: string;
  selectedValue?: string;
  /** When provided, reveals quiz feedback: correct answer highlighted in teal, wrong selection in red. */
  correctValue?: string;
  onChange?: (value: string) => void;
  className?: string;
}

export const AnswerList: React.FC<AnswerListProps> = ({
  options,
  name,
  selectedValue,
  correctValue,
  onChange,
  className,
}) => {
  const isAnswered = correctValue !== undefined;

  return (
    <div className={cn('flex flex-col gap-6', className)}>
      {options.map((option) => {
        const isSelected = option.value === selectedValue;
        const isCorrect = option.value === correctValue;
        const showAsCorrect = isAnswered && isCorrect;
        const showAsIncorrect = isAnswered && isSelected && !isCorrect;

        return (
          <Radio
            key={option.value}
            id={option.value}
            name={name}
            value={option.value}
            label={option.label}
            selected={isSelected || showAsCorrect}
            correct={showAsCorrect}
            error={showAsIncorrect}
            disabled={false}
            onChange={(value) => {
              if (!isAnswered) {
                onChange?.(value);
              }
            }}
            className="!w-full rounded-lg"
          />
        );
      })}
    </div>
  );
};

export default AnswerList;
